/* eslint-disable no-unused-vars */
/* eslint-disable max-len */

import * as ScrollMagic from 'scrollmagic';
import { TweenMax, Linear } from 'gsap/all';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import { Component } from '../core/component';

ScrollMagicPluginGsap(ScrollMagic, TweenMax);

// uncomment next line in addition .addIndicators() to show triggers for debug
/* eslint-disable-next-line */
// import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

export class Parallax extends Component {
    constructor() {
        super();
        this.selector = '[data-parallax]';
    }

    init() {
        const parallax = document.querySelectorAll(this.selector);
        const footerHeight = document.querySelector('.layoutFooter').offsetHeight;

        parallax.forEach((container) => {
            const bg = container.querySelector('[data-parallax-bg]');
            const duration = container.offsetHeight + footerHeight;

            if (!bg) return;

            const controller = new ScrollMagic.Controller({
                globalSceneOptions: {
                    triggerHook: 'onEnter',
                    duration,
                },
            });

            // build scene
            // uncomment .addIndicators to show triggers for debug
            const scene = new ScrollMagic.Scene({ triggerElement: container })
                .setTween(bg, { y: '-20%', ease: Linear.easeNone })
                // .addIndicators()
                .triggerHook(0.4)
                .addTo(controller);

            // on scroll update duration height
            window.addEventListener('scroll', () => {
                const footerHeightScroll = document.querySelector('.layoutFooter').offsetHeight;
                const durationScroll = container.offsetHeight;
                scene.duration(durationScroll + footerHeightScroll);
            });

            // on resize update duration height
            window.addEventListener('resize', () => {
                const footerHeightResize = document.querySelector('.layoutFooter').offsetHeight;
                const durationResize = container.offsetHeight;
                scene.duration(durationResize + footerHeightResize);
            });
        });
    }
}
